<template>
  <div>
    <div v-for="(charge, i) in charges" :key="i" class="mt-2 mr-3">
      <small>{{charge.date | dateFormatSimple}}</small>
      <c-row>
        <c-col sm="9">{{charge.description}}</c-col>
  <!--      <c-col>{{charge.description}}</c-col>-->
        <c-col sm="2" class="text-right">{{charge.amount}}</c-col>
        <c-col sm="1" class="text-right">
          <c-input-checkbox/>
        </c-col>
      </c-row>
    </div>
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate';
import { dateFormatNoTime, dateFormatSimple } from '@/filters';

const charges = [
  {
    date: '2023-08-24',
    description: '7-ELEVEN 1095 KILSYTH AUS',
    amount: '$9.50',
  },
  {
    date: '2023-08-22',
    description: '1ST ENERGY PTY LTD HAMPTON',
    amount: '$129.62',
  },
  {
    date: '2023-08-22',
    description: 'SPORTING GLOBE CP SOUTH MELBO',
    amount: '$21.81',
  },
  {
    date: '2023-08-21',
    description: 'COLES 0622 CHIRNSIDE P AUS',
    amount: '$34.63',

  },
  {
    date: '2023-08-21',
    description: 'Carlton Wine Room Carlton',
    amount: '$297.02',
  },
  {
    date: '',
    description: '',
    amount: 129.62,
  },
];

export default {
  name: 'CreateAsset',
  methods: { dateFormatSimple, dateFormatNoTime },
  mixins: [validationMixin],
  props: {
    show: Boolean,
  },
  data() {
    return {
      charges,
      fields: [
        { key: 'date', label: 'Date' },
        { key: 'description', label: 'Description' },
        { key: 'amount', label: 'Amount' },
      ],
    };
  },
};
</script>
